import { styled, keyframes } from '@mui/material';

export const cautionPulse = keyframes`
  0% { transform: scale(0.92); opacity: 0.7; }
  55% { transform: scale(1.28); opacity: 0; }
  100% { transform: scale(1.28); opacity: 0; }
`;

export const cautionGrow = keyframes`
  0% { transform: scale(1); }
  55% { transform: scale(1.12); }
  100% { transform: scale(1); }
`;

export const AddressNoteRoot = styled('div')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
}));

export const AddressNoteFormRoot = styled('form')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  overflowY: 'auto',
  paddingBottom: 20,
  paddingTop: 10,
  marginTop: -10,
  '&::-webkit-scrollbar': {
    width: 0,
  },

  [theme.breakpoints.up('md')]: {
    width: 700,
  },

  [theme.breakpoints.up('lg')]: {
    width: 900,
  },
}));
